import { Button, Flex, Text } from "@chakra-ui/react";
import Modal from "./Modal";
import { useState } from "react";

const DeleteComp = (props) => (
  <Flex direction={"column"} gap={"2rem"}>
    <Text>Are you sure you want to detele ?</Text>
    <Flex w={"17rem"} alignSelf={"end"} justify={"space-between"}>
      <Button
        variant={"outline"}
        w={"8rem"}
        onClick={() => {
          props.setIsOpen && props.setIsOpen(false);
        }}
      >
        Cancel
      </Button>

      <Button
        w={"8rem"}
        bg={"red"}
        onClick={() => {
          props.setIsOpen && props.setIsOpen(false);
          props.onDelete && props.onDelete();
          props?.itemData?.onDelete && props.itemData.onDelete();
        }}
      >
        Delete
      </Button>
    </Flex>
  </Flex>
);

const DeleteConfim = (props) => {
  const [isModalOp, setIsModalOp] = useState(false);

  return (
    <Flex>
      <Modal
        title={"Confirm"}
        isopen={isModalOp}
        setIsOpen={setIsModalOp}
        Child={DeleteComp}
        childData={{ itemData: { onDelete: props?.onDelete } }}
      />
      <Flex onClick={() => setIsModalOp(true)}>
        {props?.TrigarComp || null}
      </Flex>
    </Flex>
  );
};

export default DeleteConfim;
